import React from "react";
import styles from "./KeyValueTable.module.css";

const KeyValueTable = ({ data, ...props }) => {
   return (
    <div {...props}>

      <table className={styles.table}>
         <tbody>
            {Object.entries(data).map(([key, value], index) => (
                <tr key={index} className={styles.row}>
                  <td className={styles.keyColumn}>{key}</td>
                  <td className={styles.valueColumn}>{value}</td>
               </tr>
            ))}
         </tbody>
      </table>
            </div>
   );
};

export default KeyValueTable;
